import type { IVariantSummary } from "~/hooks/useVariantTableData"
import type { INpiVariantSummary } from "~/server/api/routers/npi"

/**
 * The activation date To review judges for a row. NPI rows carry it as `reviewActivatedFrom`;
 * SKU-store rows' `activatedFrom` is already `Sku.activatedFrom`, as it was before the V1 change.
 */
export const reviewActivatedFromOf = (v: INpiVariantSummary | IVariantSummary) =>
  "reviewActivatedFrom" in v.settings ? v.settings.reviewActivatedFrom : v.settings.activatedFrom
